import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as i}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as t}from"../../icon-registry.js";const o=t("norway",i`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <path
                d="M0 4.5H24V20.5H0V4.5Z"
                fill="#EF2B2D" />
            <path
                d="M6.54541 4.5H10.909V20.5H6.54541V4.5Z"
                fill="white" />
            <path
                d="M0 10.5H24V14.5H0V10.5Z"
                fill="white" />
            <path
                d="M7.63623 4.5H9.81805V20.5H7.63623V4.5Z"
                fill="#002868" />
            <path
                d="M0 11.5H24V13.5H0V11.5Z"
                fill="#002868" />
        </svg>
    `),l=i`
    <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        static>
        <mask
            id="mask0_4915_40032"
            style="mask-type:alpha"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="24"
            height="25">
            <circle
                cx="12"
                cy="12.5"
                r="12"
                fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_4915_40032)">
            <g clip-path="url(#clip0_4915_40032)">
                <path
                    d="M-5.96484 -0.59082H30.0352V25.591H-5.96484V-0.59082Z"
                    fill="#EF2B2D" />
                <path
                    d="M3.85352 -0.59082H10.399V25.591H3.85352V-0.59082Z"
                    fill="white" />
                <path
                    d="M-5.96484 9.22754H30.0352V15.773H-5.96484V9.22754Z"
                    fill="white" />
                <path
                    d="M5.48975 -0.59082H8.76247V25.591H5.48975V-0.59082Z"
                    fill="#002868" />
                <path
                    d="M-5.96484 10.8633H30.0352V14.136H-5.96484V10.8633Z"
                    fill="#002868" />
            </g>
        </g>
        <defs>
            <clipPath id="clip0_4915_40032">
                <rect
                    width="36"
                    height="24"
                    fill="white"
                    transform="translate(-5.96484 0.5)" />
            </clipPath>
        </defs>
    </svg>
`,p=t("norway_rounded",l),d=t("NOK",l);export{d as NOK,o as Norway,p as NorwayRounded,l as NorwayRoundedSvg};
